import { render, staticRenderFns } from "./view-bed.vue?vue&type=template&id=a7437cb0&scoped=true&"
import script from "./view-bed.vue?vue&type=script&lang=js&"
export * from "./view-bed.vue?vue&type=script&lang=js&"
import style0 from "./view-bed.vue?vue&type=style&index=0&id=a7437cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7437cb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
